import React, { useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { colors } from 'constants/index'

const XAutocomplete = ({
  fullWidth,
  variant,
  InputProps = {},
  InputLabelProps = {},
  value,
  options = [],
  optionLabel = 'label',
  valueName = 'value',
  label,
  placeholder,
  ...props
}) => {
  const [val, setVal] = useState('')

  useEffect(() => {
    setVal(options.find(opt => opt[valueName] === value) || '')
  }, [options, value, valueName])

  return (
    <Autocomplete
      {...props}
      options={options}
      value={val}
      getOptionLabel={option => {
        const baseLabel = `${option[optionLabel] || ''}`
        return option.isShared ? `${baseLabel} (shared)` : baseLabel
      }}
      autoHighlight
      renderOption={option => {
        const baseLabel = `${option[optionLabel] || ''}`
        return (
          <span>
            {baseLabel}
            {option.isShared && <span style={{ color: colors.BASIC.COLOR[50] }}> (shared)</span>}
          </span>
        )
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant={variant}
          fullWidth={fullWidth}
          InputLabelProps={{ ...InputLabelProps }}
          InputProps={{
            ...params.InputProps,
            ...InputProps,
          }}
        />
      )}
    />
  )
}

export default XAutocomplete
